import { useEmployeeDashboard } from "@/hooks/use-hr-queries";
import { EmployeeDashboardView } from "@/components/hr/employee-dashboard-view";
import { QueryGate } from "@/components/shell/page";

export default function EmployeeDashboardPage() {
  const { data, isLoading, error } = useEmployeeDashboard();
  return (
    <QueryGate loading={isLoading} error={error || !data ? "Could not load your day." : null}>
      {data && <EmployeeDashboardView data={data} />}
    </QueryGate>
  );
}
